import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ContentmanagementService } from './contentmanagement.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UntypedFormGroup, FormControl, ReactiveFormsModule, AbstractControl, UntypedFormBuilder, Validators } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DecoupledEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { eventNames } from 'process';




declare var $: any;
@Component({
  selector: 'app-contentmanagement',
  templateUrl: './contentmanagement.component.html',
  styleUrls: ['./contentmanagement.component.css']
})
export class ContentmanagementComponent implements OnInit, OnDestroy {
  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
  };
  private Active: any = true;
  readonly ImageRootURL = environment.baseUrl.slice(0, -3);
  public form: any;
  public file: any;
  public menuType: string;
  private navigationSubscription: any;
  public sectionOptions: string[] = [];
  public isEditCase: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, fb: UntypedFormBuilder, private toastr: ToastrService, public ContentmanagementService: ContentmanagementService, private spinner: NgxSpinnerService) {
    this.form = fb.group({
      'ID': [0],
      'Section': [null, Validators.required],
      'Title1': ['', Validators.required],
      'Title2': [''],
      'Title3': [''],
      'Description': ['', Validators.required],
      'Image': [''],
      'Type': [''],
      'Author': ['']
    });
  }

  public listHomePageSection: Array<string> = [];
  public listHomePageSectionandType: Array<string> = [];

  ngOnInit(): void {
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setMenuTypeFromQueryParams();
      }
    });

    this.setMenuTypeFromQueryParams();
  }

  private setMenuTypeFromQueryParams(): void {
    const param = this.route.snapshot.queryParamMap.get('Type');
    if (param) {
      this.menuType = param;
      this.setSectionOptions();
      this.getHomePageSection(param);
      this.onFormReset();
      this.form.setValue({ Type: this.menuType });
    }
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

  }


  public onReady(editor: DecoupledEditor): void {
    const element = editor.ui.getEditableElement()!;
    const parent = element.parentElement!;

    parent.insertBefore(
      editor.ui.view.toolbar.element!,
      element
    );
  }

  Filter(key: any, type: string) {
    if (type === 'ACTIVE-INACTIVE') {
      this.Active = key;
    };
    this.getHomePageSection(this.menuType);
  }

  setDefaultImage(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/default-product.png';
  }

  setSectionOptions(): void {
    if (this.menuType === 'FAQ') {
      this.sectionOptions = ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5', 'Section 6', 'Section 7', 'Section 8', 'Section 9', 'Section 10'];
    } else if (this.menuType === 'About-Us') {
      this.sectionOptions = ['Section 1'];
    } else if (this.menuType === 'Privacy-Policy') {
      this.sectionOptions = ['Section 1'];
    } else if (this.menuType === 'Contact-Us') {
      this.sectionOptions = ['Section 1'];
    } else if (this.menuType === 'Terms-Conditions') {
      this.sectionOptions = ['Section 1'];
    } else if (this.menuType === 'Cancellation-Policy') {
      this.sectionOptions = ['Section 1'];
    } else if (this.menuType === 'Home') {
      this.sectionOptions = ['Section 1', 'Section 2', 'Section 3'];
    } else {
      this.sectionOptions = [];
    }
  }




  getHomePageSection(type) {
    this.spinner.show();
    const uniqueSections = {};
    this.ContentmanagementService.GetHomePageSection(type).subscribe(data => {
      if (data.message === 'OK') {
        this.listHomePageSection = data.result.filter((item) => {
          if (!uniqueSections[item.section]) {
            uniqueSections[item.section] = true;
            return true;
          }
          return false;
        });
        this.getSectionListBySectionAndType();
      } else {
        this.listHomePageSection = [];
        this.listHomePageSectionandType = [];
      }
      setTimeout(() => {
        this.spinner.hide();
      }, 200);

    });

  }

  onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];
    const maxSize = 500 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg','image/webp'];

    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid File Type',
        text: 'Please upload an image file (JPEG, PNG, or JPG).',
      });
      input.value = '';
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: 'warning',
        title: 'File Too Large',
        text: 'The uploaded file must be less than 2MB.',
      });
      input.value = '';
      return;
    }

    if (this.menuType === 'Home') {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        if (image.width < 750 || image.height < 500) {
          input.value = '';
          Swal.fire({
            icon: 'warning',
            title: 'Invalid Image Dimensions',
            text: 'Image dimensions should be at least 750x500 pixels.',
          });
        } else {
          this.file = file;
        }
      };
    } else {
      this.file = file;
    }
  }

  getSectionListBySectionAndType() {
    this.spinner.show();
    setTimeout(() => {
      let dropdowntext = $('#SectionT option:selected').text();
      this.ContentmanagementService.GetSectionListBySectionAndTypeName(this.menuType, dropdowntext, 'Admin', this.Active).subscribe(data => {
        if (data.message === 'OK') {
          this.listHomePageSectionandType = data.result;
        } else {
          this.listHomePageSectionandType = [];
        }
      });
      setTimeout(() => {
        this.spinner.hide();
      }, 200);

    }, 300);

  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
  
    this.spinner.show();
    try {
      if (this.file) {
        const formData = new FormData();
        formData.append('Files', this.file);
        formData.append('Type', 'Home');
  
        const fileResponse = await this.ContentmanagementService.uploadFiles(formData).toPromise();
        if (fileResponse.message === "ok") {
          this.form.patchValue({
            Image: fileResponse.result[0].path + fileResponse.result[0].filename
          });
        }
      }
  
      const contentResponse = await this.ContentmanagementService.manageContent(this.form.value).toPromise();
      if (contentResponse.message === "OK") {
        this.toastr.success(contentResponse.activity);
        this.onFormReset();
        this.getHomePageSection(this.menuType);
        this.getSectionListBySectionAndType();
      } else {
        this.toastr.error(contentResponse.Message);
      }
    } catch (error) {
      this.toastr.error("Something went wrong. Please try again.");
    } finally {
      this.spinner.hide();
    }
  }
  

  onEdit(data: any) {
    this.isEditCase = true;
    this.form.patchValue({
      Title1: data.title1,
      Title2: data.title2,
      Title3: data.title3,
      Section: data.section,
      Description: data.description,
      ID: data.id,
      Author: data.author,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  onFormReset() {
    this.form.reset({ ID: 0, Type: this.menuType });
    this.isEditCase = false;
    this.file = null;
    const fileInput = document.getElementById('file_input') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }





  ActiveInactive(ContentID: any, IsActive: any) {
    var action = 'Activated';
    Swal.fire({
      title: IsActive ? "Are you sure you want to deactivate this content?" : "Are you sure you want to activate this content?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#297084 ',
      cancelButtonColor: '#686767',
      confirmButtonText: IsActive ? "Confirm" : "Confirm"
    }).then((result) => {
      if (result.isConfirmed) {
        if (IsActive === true) {
          action = 'Deactivated';
        }
        this.ContentmanagementService.ActiveInactiveContent(ContentID).subscribe(res => {
          this.getHomePageSection(this.menuType);
          this.toastr.success('Menu ' + action + ' successfully');
          setTimeout(() => {
            this.spinner.hide();
          }
            , 200);
        }, err => { this.spinner.hide(); this.toastr.error('', 'Not Responding'); });
      }
      else {
        debugger
        function check() {
          $('#checkBoxAinA' + ContentID).prop("checked", true)
        };
        function uncheck() {
          $('#checkBoxAinA' + ContentID).prop("checked", false)
        }

        IsActive ? check() : uncheck();
      }
    })
  }


}





